import type { JSX } from 'react';
import { Controller, FieldValues } from 'react-hook-form';

import { FormFieldWrapperProps } from '@/widgets/ServiceFormTemplate';

import { SwitchOwnProps, Switch } from '@/shared/ui';

export function FormSwitch<T extends FieldValues = FieldValues>({
  name,
  control,
  errorMessage,
  ...restProps
}: SwitchOwnProps & FormFieldWrapperProps<T>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error: fieldError } }): JSX.Element => (
        <Switch {...field} errorMessage={fieldError?.message || errorMessage} {...restProps} />
      )}
    />
  );
}
